<template>
    <div>
        <b-form @submit.prevent="onSearch">
            <b-form-group label="Trouvez une agence près de chez vous">
                <b-input-group>
                    <b-form-input v-model="searchAddress" type="text" placeholder="Votre adresse, ville ou code postal"></b-form-input>
                    <b-input-group-append>
                        <b-button variant="primary" type="submit">Trouver</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </b-form>
        <div style="overflow: scroll; height: 730px">
            <b-list-group flush>
                <b-list-group-item v-for="store in stores" :key="store.rowId">
                    <b>{{store.shortTitle}}</b><span v-if="store.distance < 2000">{{` (${Math.round(store.distance)} km)`}}</span><br/>
                    {{store.address1}}<br/>
                    <span v-if="store.address2">{{store.address2}}<br/></span>
                    {{store.zip + ' ' + store.city}}

                    <div v-if="store.phone">
                        <Icon name="phone" />
                        <b-link :href="`tel:${store.phone}`">{{ formatPhone(store.phone) }}</b-link><br/>
                    </div>
                    <div v-if="store.email">
                        <Icon name="envelope" />
                        <b-link :href="`mailto:${store.email}`">{{store.email}}</b-link><br/>
                    </div>
                    <b-button v-b-modal="'modal-' + store.title" variant="outline-primary" class="mt-2" size="sm">Plus d'infos</b-button>
                    <StoreModal :storeId="store.id" :modalId="'modal-' + store.title" :storeTitle="store.title"/>
                </b-list-group-item>
            </b-list-group>
        </div>
    </div>
</template>

<script>
    import StoreModal from './StoreModal.vue'

    export default {
        name: 'StoresList',

        components: {
            StoreModal,
        },

        data() {
            return {
                searchAddress : "",
            }
        },

        store : {
            stores: 'stores',
        },

        methods : {
            onSearch() {
                this.$root.$emit('search:address', this.searchAddress)
            },
            getUrlAddress() {
                const params = (new URL(document.location)).searchParams
                const address = params.get('address')
                if (address) {
                    this.searchAddress = decodeURIComponent(address)
                    this.onSearch()
                }
            },
        },

        mounted() {
            setTimeout(() => {
                this.getUrlAddress()
            })
        },
    }
</script>
